import axios from './axios-auth';

const getAllCustomers = async ({ current, pageSize, sortField, sortOrder, searchTerm }) => {
  try {
    const { data } = await axios.get(
      `/dv-adm/getallcustomers?searchTerm=${searchTerm}&pageNumber=${current}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&user_type=0&lock_status_type=2`
    );
    return data;
  } catch (e) {
    console.log(e);
  }
};
const getUnitTypes = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/dv-adm/getunittypes',
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching unit types api');
      });
  });

const getTree = (customerId) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/gettree?customerid=${customerId}`,
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching unit types api');
      });
  });

const associateUnit = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/dv-adm/associateunit',
      method: 'PUT',
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get tax reporting database report api');
      });
  });

const unassociateUnit = ({ id, parentId }) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/unassociateunit?id=${id}&parentid=${parentId}`,
      method: 'PUT',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get tax reporting database report api');
      });
  });

const getCustomerById = (customerId) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/getcustomerbyid?id=${customerId}`,
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching unit types api');
      });
  });

const getBusinessUnitById = (id) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/getbusinessunitbyid?id=${id}`,
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching unit types api');
      });
  });

const updateBusinessUnitById = ({ id, unitTypeId }) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/updatebusinessunitbyid?id=${id}&unittypeid=${unitTypeId}`,
      method: 'PUT',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get tax reporting database report api');
      });
  });

const addUnitType = ({ name, customerId }) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/addunittype?name=${name}&customerid=${customerId}`,
      method: 'POST',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get tax reporting database report api');
      });
  });

const editUnitType = ({ name, unitTypeId }) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/dv-adm/editunittype?name=${name}&unittypeid=${unitTypeId}`,
      method: 'PUT',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get tax reporting database report api');
      });
  });

const addBusinessUnit = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: '/dv-adm/addbusinessunit',
      method: 'POST',
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error from get tax reporting database report api');
      });
  });

const getUnassociatedClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: '/dv-adm/getunassociatedclients',
      method: 'GET',
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log('error while fetching unit types api');
      });
  });

export {
  getAllCustomers,
  getUnitTypes,
  getTree,
  associateUnit,
  unassociateUnit,
  getCustomerById,
  getBusinessUnitById,
  updateBusinessUnitById,
  addUnitType,
  editUnitType,
  addBusinessUnit,
  getUnassociatedClients,
};
